import { useContext } from 'react';
import { MainContext, MainContextType } from 'Contexts';

export const useMainContext = (): MainContextType => {
  const context = useContext(MainContext);

  return context;
};
